export default __webpack_public_path__ + "static/normal-noise-min-1043937a300652923e16c595ff8f907a.png";